export const FEATURE_GROUP_TO_URL_PARAM_MAP = {
  AUTOMATION: 'automation',
  BREEZE_INTELLIGENCE: 'breeze-intelligence',
  BREEZE_AGENTS: 'breeze-agents',
  BREEZE_AUTOMATION: 'breeze-automation',
  BUYER_INTENT: 'buyer-intent',
  DATA_STUDIO: 'data-studio',
  EVENTS: 'events',
  MESSAGING: 'messaging',
  CPQ: 'cpq',
  CALLING: 'calling',
  TEST_FEATURE_GROUP: 'test-feature-group'
};
export const FEATURE_TYPE_TO_URL_PARAM_MAP = {
  PROSPECTING_AGENT: 'prospecting-agent',
  ENRICHMENT: 'enrichment',
  CUSTOMER_AGENT: 'customer-agent',
  INTENT: 'intent',
  DATA_AGENT: 'data-agent',
  WORKFLOWS: 'workflows',
  DATA_STUDIO_SYNC: 'data-studio-sync',
  CLOSING_AGENT: 'closing-agent',
  EMAIL_SEND: 'email-send',
  WHATSAPP: 'whatsapp',
  QUOTES_ACCEPTED: 'quotes-accepted',
  CALLING_MINUTES: 'calling-minutes',
  TEST_FEATURE_TYPE: 'test-feature-type',
  UNIFIED_EVENTS: 'unified-events',
  WORKFLOWS_NON_AI_EXECUTIONS: 'workflows-non-ai-executions',
  CUSTOM_EVENTS: 'custom-events'
};

// Reusable placeholder constants
export const PORTAL_ID_PLACEHOLDER_NAME = 'portalId';
export const PORTAL_ID_PLACEHOLDER = `{${PORTAL_ID_PLACEHOLDER_NAME}}`;

// Type that enforces URLs must contain the specified placeholder

// Type-safe mapping that enforces placeholder presence

/**
 * Type-safe function to create feature type URL mappings.
 * TypeScript will throw errors if {portalId} is renamed in any URL.
 */
function createFeatureTypeViewSourceUrlMap(urlMap) {
  return urlMap;
}

// Example usage - this function enforces type safety at compile time
export const FEATURE_TYPE_TO_VIEW_SOURCE_URL_MAP = createFeatureTypeViewSourceUrlMap({
  PROSPECTING_AGENT: `/prospecting-agent-ui/${PORTAL_ID_PLACEHOLDER}/overview`,
  DATA_AGENT: `/data-agent/${PORTAL_ID_PLACEHOLDER}`,
  WORKFLOWS: `/workflows/${PORTAL_ID_PLACEHOLDER}/view/default`,
  WORKFLOWS_NON_AI_EXECUTIONS: `/workflows/${PORTAL_ID_PLACEHOLDER}/view/default`,
  INTENT: `/buyer-intent/${PORTAL_ID_PLACEHOLDER}/signals`,
  DATA_STUDIO_SYNC: `/data-studio-home/${PORTAL_ID_PLACEHOLDER}`,
  ENRICHMENT: `/settings/${PORTAL_ID_PLACEHOLDER}/enrichment`,
  CLOSING_AGENT: `/closing-agent/${PORTAL_ID_PLACEHOLDER}/overview`,
  CUSTOMER_AGENT: `/customer-agent/${PORTAL_ID_PLACEHOLDER}/assignment`,
  EMAIL_SEND: `/email/${PORTAL_ID_PLACEHOLDER}`,
  WHATSAPP: `/conversations/${PORTAL_ID_PLACEHOLDER}/channels/whatsapp`,
  QUOTES_ACCEPTED: `/quotes/${PORTAL_ID_PLACEHOLDER}`,
  CALLING_MINUTES: `/settings/${PORTAL_ID_PLACEHOLDER}/user-preferences/calling`,
  UNIFIED_EVENTS: `/events/${PORTAL_ID_PLACEHOLDER}`,
  CUSTOM_EVENTS: `/events/${PORTAL_ID_PLACEHOLDER}`,
  TEST_FEATURE_TYPE: `/test-feature-type/${PORTAL_ID_PLACEHOLDER}`
});
export const FEATURE_TYPE_TO_FEATURE_GROUP_MAP = {
  PROSPECTING_AGENT: 'BREEZE_AGENTS',
  CUSTOMER_AGENT: 'BREEZE_AGENTS',
  CLOSING_AGENT: 'BREEZE_AGENTS',
  DATA_AGENT: 'BREEZE_AGENTS',
  ENRICHMENT: 'BREEZE_INTELLIGENCE',
  INTENT: 'BUYER_INTENT',
  WORKFLOWS: 'BREEZE_AUTOMATION',
  WORKFLOWS_NON_AI_EXECUTIONS: 'AUTOMATION',
  DATA_STUDIO_SYNC: 'DATA_STUDIO',
  EMAIL_SEND: 'MESSAGING',
  WHATSAPP: 'MESSAGING',
  QUOTES_ACCEPTED: 'CPQ',
  CALLING_MINUTES: 'CALLING',
  UNIFIED_EVENTS: 'EVENTS',
  TEST_FEATURE_TYPE: 'TEST_FEATURE_GROUP',
  CUSTOM_EVENTS: 'EVENTS'
};
export const URL_PARAM_TO_FEATURE_GROUP_MAP = Object.fromEntries(Object.entries(FEATURE_GROUP_TO_URL_PARAM_MAP).map(([key, value]) => [value, key]));
export const URL_PARAM_TO_FEATURE_TYPE_MAP = Object.fromEntries(Object.entries(FEATURE_TYPE_TO_URL_PARAM_MAP).map(([key, value]) => [value, key]));
export const BILLABLE_METRIC_TYPE_TO_FEATURE_TYPE_MAP = {
  BREEZE_CONTACT_ENRICHMENT: 'ENRICHMENT',
  BREEZE_COMPANY_ENRICHMENT: 'ENRICHMENT',
  BREEZE_SMART_PROPERTY: 'ENRICHMENT',
  CUSTOMER_AGENT_TEXT_CONVERSATION: 'CUSTOMER_AGENT',
  PROSPECTING_AGENT_CONTACT_MONITORING: 'PROSPECTING_AGENT',
  PROSPECTING_AGENT_COMPANY_RESEARCH: 'PROSPECTING_AGENT',
  DATA_AGENT_PROMPT_RESPONSE: 'DATA_AGENT',
  CLOSING_AGENT_CONVERSATION: 'CLOSING_AGENT',
  WORKFLOWS_BREEZE_ACTION: 'WORKFLOWS',
  INTENT_MONITORING: 'INTENT',
  DATA_HUB_SMALL_SYNC: 'DATA_STUDIO_SYNC',
  DATA_HUB_MEDIUM_SYNC: 'DATA_STUDIO_SYNC',
  DATA_HUB_LARGE_SYNC: 'DATA_STUDIO_SYNC',
  WHATSAPP_MESSAGE_SENT: 'WHATSAPP',
  EMAIL_SEND: 'EMAIL_SEND',
  QUOTE_ACCEPTED: 'QUOTES_ACCEPTED',
  CALLING_MINUTES: 'CALLING_MINUTES',
  WORKFLOWS_NON_AI_ACTION: 'WORKFLOWS_NON_AI_EXECUTIONS',
  CUSTOM_EVENTS: 'CUSTOM_EVENTS',
  TEST_BILLABLE_METRIC: 'TEST_FEATURE_TYPE',
  TEST_PRICING_RATE_CARD: 'TEST_FEATURE_TYPE',
  TEST_CHANGE_MANAGEMENT_RATE_CARD: 'TEST_FEATURE_TYPE'
};